import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingArgument } from './components/ClosingArgument';
import { EverythingIncluded } from './components/EverythingIncluded';
import { VisualSection } from './components/VisualSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { ProductGallery } from './components/ProductGallery';
import { SolutionReveal } from './components/SolutionReveal';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VolumesSection } from './components/VolumesSection';
import { META_PIXEL_ID } from './utils/tracking';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showTestimonials?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showTestimonials = true,
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-white text-graphite" data-id="element-0" data-mp="3gl4pnbwh7qhe">
      <main data-id="element-1" data-mp="3gja7g5clach0">
        <Hero data-id="element-2" data-mp="3bmbdpnwu87jc" />
        {showTestimonials && <TestimonialsStrip data-id="element-3" data-mp="3bn314bga6yyj" />}
        <ProductGallery data-id="element-4" data-mp="3bnus18yxo8ih" />
        <PainPoints data-id="element-5" data-mp="3bkgs07dqsbe7" />
        <SolutionReveal data-id="element-6" data-mp="3qaxuzv60z9d7" />
        <VisualSection data-id="element-7" data-mp="3qc950cq2ddcr" />
        <VolumesSection data-id="element-8" data-mp="3qciln9p7y85s" />
        <BonusSection data-id="element-9" data-mp="3qd0owqaatmn7" />
        <PricingSection data-id="element-10" data-mp="3ljxtsdpvi54w" />
        <ClosingArgument data-id="element-11" data-mp="3ljphamxnx1u8" />
        <Guarantee data-id="element-12" data-mp="3lj67jti61jra" />
        <FAQ data-id="element-13" data-mp="2xuwtxev3w2b8" />
        <FinalCTA data-id="element-14" data-mp="2xun3xra29v5j" />
        <EverythingIncluded data-id="element-15" data-mp="2xu3mscs8jask" />
      </main>
      <Footer data-id="element-16" data-mp="2xssfw43htmx8" />
      {showPurchaseNotifications && <PurchaseNotification data-id="element-17" data-mp="2swbpt4cqgyhi" />}
      <noscript data-id="element-18" data-mp="2svah36j6wo2y">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-19" data-mp="2svjyw6u2zoxk" />
      </noscript>
    </div>;
}